exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".code-block-code-block-wNXwhYtumwr{background-color:var(--codeblock-bg)}.code-block-code-block-wNXwhYtumwr .code-block-code-tvn2TnN7mwr{white-space:pre;overflow-x:auto;margin:auto 0;font-size:12px}.code-block-code-block-wNXwhYtumwr .code-block-terminal-42u6IZ1Nmwr{margin:auto 0}.code-block-inline-code-block-2DWHm5Jmmwr{font-family:\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;display:inline-block;padding:4px;line-height:1;background-color:white;white-space:pre;font-size:12px}.code-block-dark-4ZN9ZDAAmwr{background-color:var(--terminal-bg)}.code-block-light-4t7tRn8Pmwr{background-color:var(--codeblock-bg)}.code-block-terminal-42u6IZ1Nmwr{font-family:\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;color:var(--always-light-text)}.code-block-terminal-42u6IZ1Nmwr::before{content:\"$\";margin-right:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"code-block": "code-block-code-block-wNXwhYtumwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["padding-xs"] + "",
	"codeBlock": "code-block-code-block-wNXwhYtumwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["padding-xs"] + "",
	"code": "code-block-code-tvn2TnN7mwr",
	"terminal": "code-block-terminal-42u6IZ1Nmwr",
	"inline-code-block": "code-block-inline-code-block-2DWHm5Jmmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["rounded-sm"] + "",
	"inlineCodeBlock": "code-block-inline-code-block-2DWHm5Jmmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["rounded-sm"] + "",
	"dark": "code-block-dark-4ZN9ZDAAmwr",
	"light": "code-block-light-4t7tRn8Pmwr"
};